var colorManipulator = {};

export { colorManipulator as __exports };
